export class SystemIdentityValue {
    static create() {
        return {
            id: "system",
            type: "admin",
            displayName: "System"
        };
    }
}
